import {
  Dispatch,
  FILTER_ACCOMMODATION_TYPE_TOGGLE,
  FILTER_FEATURE_TOGGLE,
  FILTER_REMOVE_ALL,
  FILTER_SITE_FEATURE_TOGGLE,
  FILTER_UPDATE_MIN_MAX_PRICE,
} from '@awaze/mfe-common.contexts.search'

import {
  HandleChipClickProps,
  HandleClearAllClickProps,
  HandleFilterClickProps,
  HandleMappedFilterClickProps,
} from '@/containers/Filters/Filters.types'

import {
  fireChipRemoved,
  fireFacetClearAll,
  fireFacetToggled,
} from './fireFacetEvents'

export const handleFilterClick = ({
  allFeatures,
  appliedFeatures,
  clickedFeature,
  dispatch,
  tms,
  optiContext,
}: HandleFilterClickProps): void => {
  const {
    featureId,
    featureGroup,
    featureName,
    isAccommodationFeature,
    isSiteFeature,
    featureGroupId,
  } = clickedFeature

  if (typeof featureId === 'string' && typeof featureName === 'string') {
    fireFacetToggled({
      allFeatures,
      appliedFeatures,
      clickedFeature: {
        featureId,
        featureGroup,
        featureName,
        featureGroupId,
      },
      tms,
      optiContext,
    })

    if (isAccommodationFeature) {
      dispatch({
        type: FILTER_ACCOMMODATION_TYPE_TOGGLE,
        accommodationTypeId: featureId,
      })
    } else if (isSiteFeature) {
      dispatch({ type: FILTER_SITE_FEATURE_TOGGLE, siteFeatureId: featureId })
    } else {
      dispatch({ type: FILTER_FEATURE_TOGGLE, featureId: featureId })
    }
  }
}

export const handleMappedFilterClick = ({
  allFeatures,
  appliedFeatures,
  clickedFeature,
  dispatch,
  dispatchType,
  tms,
  optiContext,
}: HandleMappedFilterClickProps): void => {
  const { featureId, featureGroup, featureName, featureGroupId } =
    clickedFeature

  if (typeof featureId === 'string' && typeof featureName === 'string') {
    fireFacetToggled({
      allFeatures,
      appliedFeatures,
      clickedFeature: {
        featureId,
        featureGroup,
        featureName,
        featureGroupId,
      },
      tms,
      optiContext,
    })

    dispatch({ type: dispatchType, id: featureId })
  }
}

export const handleClearAllClick = ({
  dispatch,
  tms,
}: HandleClearAllClickProps): void => {
  fireFacetClearAll({
    tms,
  })

  dispatch({
    type: FILTER_REMOVE_ALL,
  })
}

export const handleChipClick = ({
  tms,
  clickedFeature,
}: HandleChipClickProps): void => {
  const { featureName, featureGroup } = clickedFeature

  if (typeof featureName === 'string') {
    const defaultedGroupClickedFeature = {
      featureGroup: featureGroup ?? '',
      featureName,
    }

    fireChipRemoved({
      clickedFeature: defaultedGroupClickedFeature,
      tms,
    })
  }
}

export const handleMinMaxPriceFilterKeyPress = (
  event: React.KeyboardEvent<HTMLInputElement>,
): void => {
  // allowed key codes correspond to the following keys: [delete, tab, return, arrow keys,  0...9]
  const allowedKeyCodes = [
    8, 9, 13, 37, 38, 39, 40, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97,
    98, 99, 100, 101, 102, 103, 104, 105,
  ]

  if (!allowedKeyCodes.includes(event.keyCode)) {
    event.preventDefault()
  }
}

export const handlePriceFilterSubmit = (
  // TODO fix typings for data and setState
  data: { [x: string]: unknown },
  setPriceRangeError: (a: boolean) => void,
  dispatch: Dispatch,
): void => {
  const minPrice = parseInt(String(data.minPrice))
  const maxPrice = parseInt(String(data.maxPrice))

  setPriceRangeError(false)

  minPrice > 0 &&
    maxPrice > 0 &&
    minPrice >= maxPrice &&
    setPriceRangeError(true)

  dispatch({
    type: FILTER_UPDATE_MIN_MAX_PRICE,
    minPrice,
    maxPrice,
  })
}

export const handlePriceFilterChange = (
  values: {
    minPrice?: string | number
    maxPrice?: string | number
  },
  // TODO fix typing for set state
  setPriceRangeError: (a: boolean) => void,
): void => {
  const checkLength = 2
  const minPrice = values.minPrice ? String(values.minPrice) : ''
  const maxPrice = values.maxPrice ? String(values.maxPrice) : ''
  setPriceRangeError(false)

  if (minPrice.length > checkLength && maxPrice.length > checkLength) {
    parseInt(minPrice) >= parseInt(maxPrice) && setPriceRangeError(true)
  }
}
